export enum ProfileTypes {
  master = 'master',
  admin = 'admin',
  paymaster = 'paymaster',
  operator = 'operator',
}
